import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../../store";
import {
  setLoading,
  setTotal,
  setBalances,
} from "../../store/slices/holidayBalancesSlice.ts";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import { getBalancesTotals } from "../../services/holidays.service.ts";
import FilterHolidayBalances from "../../components/holidays/FilterHolidayBalances.tsx";
import HolidayBalancesGroupedTable from "../../components/holidays/HolidayBalancesGroupedTable.tsx";
import Loader from "../../components/Loader.tsx";
import Title from "../../components/Title.tsx";
import { notification } from "../../utils/Notifications.tsx";
import Layout from "../../components/Layout.tsx";

const HolidayBalancesTable = () => {
  useAppSettings();
  const dispatch = useDispatch();
  const { bossId } = useParams();
  const { page, limit, query, sortBy, defaultSort, loading } = useSelector(
    (state: RootState) => state.holidayBalances
  );

  React.useEffect(() => {
    fetchBalances();
  }, [page, limit, query, sortBy, defaultSort, bossId]);

  const fetchBalances = async () => {
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;

      const param = query.includes("param=")
        ? query.split("param=")[1]?.split("&")[0] || ""
        : "";
      const branchId = query.includes("branchId=")
        ? query.split("branchId=")[1]?.split("&")[0] || "all"
        : "all";
      const vacationType = query.includes("vacationType=")
        ? query.split("vacationType=")[1]?.split("&")[0] || "all"
        : "all";

      const params = {
        limit,
        offset,
        param,
        branchId,
        vacationType,
        sort: sortBy,
        order: defaultSort,
        ...(bossId && { bossId: Number(bossId) }),
      };

      console.log("Fetching balances with params:", params);
      const response = await getBalancesTotals(params);
      console.log("Response received:", {
        data: response.data?.length,
        total: response.total,
      });
      dispatch(setBalances(response.data));
      dispatch(setTotal(response.total));
    } catch (error) {
      console.error("Error fetching balances:", error);
      notification("Error", error.message, "danger");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Balances de Vacaciones"
        basePath="/vacaciones"
        title={
          bossId
            ? "Balances de Vacaciones de mis empleados"
            : "Balances de Vacaciones"
        }
      />
      <div className="card border-0 m-4">
        <div className="tab-content p-3">
          <div className="tab-pane fade show active">
            <FilterHolidayBalances />
            <HolidayBalancesGroupedTable />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HolidayBalancesTable;
